module.exports = __webpack_public_path__ + "img/13.260405b1.jpg";